import React from 'react';
import S from './TopLinkListMobile.styles';
const TopLinkListMobile = ({ items = [] }) => {
    return (React.createElement(S.Container, null,
        React.createElement("hr", null),
        items.map(item => (React.createElement(S.Link, { key: item.id, href: item.url }, item.text)))));
};
export default TopLinkListMobile;
